import { useEffect, useRef, useState } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { PerformanceLoggerWithMainDsn as PerformanceLogger } from 'builder/services/PerformanceLogger'
import { useComponentWillMount } from 'builder/hooks/useComponentWillMount'
import { selectors } from 'builder/modules/interview/interviewModule'
import { QuestionLibrarySection } from './components/QuestionLibrarySection/QuestionLibrarySection'
import { ActiveInterviews } from './components/ActiveInterviews/ActiveInterviews'
import { CompanyInterview } from './components/CompanyInterview/CompanyInterview'
import { Wrapper } from './styles'
import { MyInterviews } from './components/MyInterview/MyInterviews'

export interface InitialRequest {
  dailyRequest: boolean
  interviews: boolean
  questionsLibrary: boolean
  companyInterview: boolean
}
export const InterviewDashboardView = () => {
  const navigate = useNavigate()
  const [initialRequest, setInitialRequest] = useState<InitialRequest>()
  const performanceFinished = useRef(false)

  const jobTitleId = useSelector(selectors.jobTitleId)
  const jobTitleReady = useSelector(selectors.jobTitleReady)
  const [ready, setReady] = useState(false)

  useComponentWillMount(() => {
    PerformanceLogger.listen({
      name: 'interview-dashboard-page',
    })
    setInitialRequest({
      dailyRequest: false,
      interviews: false,
      questionsLibrary: false,
      companyInterview: false,
    })
  })

  useEffect(() => {
    const countRequest = Object.values(initialRequest || {})
    if (
      countRequest.length === 4 &&
      countRequest.find(r => r === false) === undefined &&
      performanceFinished.current === false
    ) {
      setInitialRequest(undefined)
      performanceFinished.current = true
      PerformanceLogger.finish()
    }
  }, [initialRequest])

  useEffect(() => {
    if (!jobTitleReady) {
      return
    }
    if (jobTitleId == null) {
      return navigate('/interview-preparation/new')
    }
    setReady(true)
    trackInternalEvent('visit_interview_dash', {
      label: 'interview_prep',
    })
    return () => {
      if (performanceFinished.current === false) {
        PerformanceLogger.skipCurrent()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobTitleReady])

  if (!ready) {
    return null
  }

  return (
    <Wrapper>
      <MyInterviews setInitialRequest={setInitialRequest} />
      <ActiveInterviews setInitialRequest={setInitialRequest} />
      <QuestionLibrarySection setInitialRequest={setInitialRequest} />
      <CompanyInterview setInitialRequest={setInitialRequest} />
    </Wrapper>
  )
}
